<script setup>
import { useStoreStore } from '@stores/store'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref } from 'vue'

import Button from '@components/global/button.vue'
import MerchCard from '@components/global/merch-card.vue'

defineProps(['collection'])

const slider = ref({})
const onSwiper = (swiper) => {
	slider.value = swiper
}

const breakpoints = ref({
	0: {
		slidesPerView: 1,
	},
	768: {
		slidesPerView: 2,
		spaceBetween: '5',
	},
	1024: {
		slidesPerView: 3,
		spaceBetween: '5',
	},
	1400: {
		slidesPerView: 4,
		spaceBetween: '24',
	},
})

const store = useStoreStore()
</script>
<template>
	<section class="container">
		<div class="flex flex-col justify-between gap-4 md:flex-row">
			<div class="flex flex-col justify-between gap-3 md:flex-row md:items-center md:justify-normal">
				<h4 class="font-extrabold">{{ collection.title }}</h4>
				<Button
					label="Shop All"
					class="secondary btn-md min-w-[120px]"
					:to="{
						name: 'collection',
						params: {
							slug: collection.slug,
						},
					}" />
			</div>
			<div class="flex justify-between">
				<Button
					label="Shop All"
					class="secondary btn-sm min-w-[120px]"
					:to="{
						name: 'collection',
						params: {
							slug: collection.slug,
						},
					}" />
				<div class="flex gap-4 self-center md:self-start">
					<Button :simple="true" @click="slider.slidePrev()" class="secondary icon">
						<i class="fa-regular fa-arrow-left" />
					</Button>
					<Button :simple="true" @click="slider.slideNext()" class="secondary icon">
						<i class="fa-regular fa-arrow-right h-4 w-4" />
					</Button>
				</div>
			</div>
		</div>
		<Swiper class="mt-4 md:mt-12" @swiper="onSwiper" :slides-per-view="4" :space-between="24" :breakpoints="breakpoints" :allowTouchMove="false" :loop="true">
			<SwiperSlide v-for="item of collection.products" :key="item.id">
				<MerchCard :item="item" />
			</SwiperSlide>
		</Swiper>
	</section>
</template>
<style scoped>
.btn.icon {
	@apply h-10 w-10;
}

.btn-md {
	@apply hidden md:flex;
}

.btn-sm {
	@apply flex md:hidden;
}
</style>
